import React from "react"

import { joinClasses, useClasses } from "../globals";

import {
  Box,
  Collapse,
  Link,
  Typography
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"


export const ReviewerForbidden = () => {
  const classes = useClasses();
  const notPreview = (new URL(window.location.href)).pathname.indexOf(`/preview`) < 0;

  return (
    <React.Fragment>
      <Box
        className={joinClasses(
          classes._Padding,
          classes._Flex,
          classes._FlexDirectionColumn
        )}
      >
        <Box className={classes._Margin}>
          <Collapse in>
            <Alert severity="error">
              <Typography>
                {notPreview ? "Reviewer links can only be used to access the project preview." : "This Reviewer link is no longer valid."}
              </Typography>
            </Alert>
          </Collapse>
        </Box>
      </Box>
    </React.Fragment>
  )
}

ReviewerForbidden.title = "Invalid Link";